export default __webpack_public_path__ + "static/throwing-wood-into-fire-pit-798bd8f75614549804f206ea3831e80f.jpg";